<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>车型单价</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form
        :inline="true"
        :model="searchFrom"
        ref="searchFrom"
        class="demo-form-inline"
        label-width="90px"
        size="mini"
      >
        <div class="inpBox">
          <el-form-item label="车型:" prop="vhcTypeId">
            <el-select v-model="searchFrom.vhcTypeId" filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in carTypeOptions"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计价方式:" prop="pricingMethod">
            <el-select v-model="searchFrom.pricingMethod"  placeholder="请选择">
              <el-option
                v-for="(item, index) in pricingMethodOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="00MP004B001" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="00MP004B002" v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addBtnClick" btnCode="00MP004B003" v-if="btnFlg[2]">新增</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableList"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%; margin-top: 10px"
        center
        @row-click="handleRowClick"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }"
        highlight-current-row
      >
        <!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="customerName" label="操作" width="120" align="center" >
          <template slot-scope="scope"><div>
            <el-button @click="changeDataClick(scope.row)" type="text" size="small" btnCode="00MP004B004" v-if="btnFlg[3]">修改</el-button>
            <el-button @click="detailsClick(scope.row)" type="text" size="small"  btnCode="00MP004B005" v-if="btnFlg[4]">删除</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="vhcTypeName" label="车型" align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="tonnageModel" label="吨位/规格" align="center"  :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="pricingMethod" label="计价方式" align="center"  :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="price" label="单价" align="center"  :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="createUserName" label="创建人" align="center" ></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="180">
          <template slot-scope="scope"><div>
            <span>{{scope.row.createTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="updateTime" label="修改时间" align="center" width="180" :formatter="formatterRowEmpty">
           <template slot-scope="scope"><div>
            <span>{{scope.row.updateTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 添加/编辑 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addAndChangeMark"
    @close="closeDialog('addAndChangeFrom')"
    width="500px"
    center>
      <div v-loading='addAndChangeLoading'>
      <div class="bigBox">
        <el-form
          :model="addAndChangeFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          :inline="true"
          ref="addAndChangeFrom"
          class=""
          label-width="110px" size="mini">
        <div class="" style="">
          <div style="margin-top:20px;">
            <el-form-item label="车型:" prop="carType" style="" >
              <el-select v-model="addAndChangeFrom.carType" @change="carTypeChange(addAndChangeFrom.carType)" filterable :disabled='changeCarType' placeholder="请选择" style="width:200px;">
                <el-option
                v-for="(item, index) in carTypeOptions"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-top:20px;">
            <el-form-item label="吨位/车型:" prop="tonnage" style="" >
              <el-select v-model="addAndChangeFrom.tonnage" :disabled='changeTonnage' placeholder="请选择" style="width:200px;">
                <el-option
                  v-for="(item,index) in tonnageOptions"
                  :key="index"
                  :label="item.type2name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-top:20px;">
            <el-form-item label="计价方式:" prop="pricingMethod" style="">
              <el-select v-model="addAndChangeFrom.pricingMethod" @change="pricingTypeChange(addAndChangeFrom.pricingMethod)" :disabled='changePricingMethod' placeholder="请选择" style="width:200px;">
                <el-option
                  v-for="(item,index) in pricingMethodOptions"
                  :key="index"
                  :label="item.showName"
                  :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-top:20px;">
            <el-form-item label="单价:" prop="monovalent" style="">
              <el-input placeholder="" maxlength="" v-number-input.float="3"  v-model.trim="addAndChangeFrom.monovalent" style="width:200px;"></el-input>
              <span>元/{{jiJiaType}}</span>
            </el-form-item>
          </div>
        </div>
        </el-form>
      </div>
      <div  style="width:130px;margin:15px auto;">
         <el-button type="primary" @click="submitForm('addAndChangeFrom')" size='mini'>提交</el-button>
        <el-button @click="resetForm('addAndChangeFrom')" size='mini'>取消</el-button>
      </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  vheTypeList, // 车型下拉框
  priceMethodPullDownMenu, // 计价方式
  vehicleModelPriceList, // 列表
  managerdDelete, // 删除
  addVehicleModelPrice, // 添加
  listByTypeId, // 获取机型/吨位下拉框
  getVehicleModelPrice, // 通过id获取单价信息主要是为了回显
  updatePrice // 修改
} from '@/api/zhbPlantVehicles.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00MP004B001',
        '00MP004B002',
        '00MP004B003',
        '00MP004B004',
        '00MP004B005'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10
      },
      // 车型
      carTypeOptions: [],
      // 计价方式
      pricingMethodOptions: [],
      tonnageOptions: [],
      tableList: [],
      tabLoading: false,
      // 新增/修改
      addAndChangeMark: false,
      addAndChangeLoading: false,
      addAndChangeFrom: {
        carType: '', // 用车单位
        attribute: '',
        monovalent: '', // 单价
        pricingMethod: '', // 计价方式
        tonnage: ''// 吨位
      },
      rules: {
        carType: [
          { required: true, message: '请选择车型', trigger: 'blur' }
        ],
        monovalent: [
          { required: true, message: '请填写单价', trigger: 'blur' }
        ],
        pricingMethod: [
          { required: true, message: '请选择计价方式', trigger: 'blur' }
        ]
        // tonnage: [
        //   { required: true, message: '请选择吨位/车型', trigger: 'blur' }
        // ]
      },
      changeCarType: false,
      changeTonnage: false,
      changePricingMethod: false,
      jiJiaType: '小时',
      isAdd: false,
      rowId: ''
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/vehicleController/unitPrice')
    this.getSeatchData(this.searchFrom)
    this.priceMethodPullDownMenu()
    this.getVheTypeList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 150 + 'px'
  },
  methods: {
    // 时间格式化
    timeStamp (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    // 年月日
    timeStamp2 (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 获取车型下拉框
    getVheTypeList () {
      vheTypeList()
        .then((res) => {
          this.carTypeOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 计价方式下拉框
    priceMethodPullDownMenu () {
      priceMethodPullDownMenu()
        .then((res) => {
          this.pricingMethodOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      vehicleModelPriceList(this.searchFrom)
        .then((res) => {
          this.tabLoading = false
          this.tableList = res.list
          this.total = res.total
        })
        .catch((err) => {
          this.tabLoading = false
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10
      }
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableList.toggleRowSelection(row)
      // this.changeData = row
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 数组求和
    sum (arr) {
      var s = 0
      arr.forEach(function (val, idx, arr) {
        s += val
      }, 0)
      return s
    },
    // 点击添加
    addBtnClick () {
      this.addAndChangeMark = true
      this.title = '添加'
      this.isAdd = true
      this.changeCarType = false
      this.changeTonnage = false
      this.changePricingMethod = false
    },
    // 点击修改
    changeDataClick (row) {
      this.addAndChangeMark = true
      this.title = '修改'
      this.isAdd = false
      this.changeCarType = true
      this.changeTonnage = true
      this.changePricingMethod = true
      // this.addAndChangeFrom.pricingMethod = row.pricingMethod
      this.rowId = row.id
      this.addAndChangeLoading = true
      getVehicleModelPrice(row.id)
        .then((res) => {
          this.addAndChangeLoading = false
          this.addAndChangeFrom.carType = res.tUpriceVehicletype.vhcTypeId
          this.addAndChangeFrom.tonnage = res.tUpriceVehicletype.tonnageModel
          this.addAndChangeFrom.pricingMethod = res.pricingMethod.showName
          this.addAndChangeFrom.monovalent = res.tUpriceVehicletype.unitPrice
          this.jiJiaType = res.pricingMethod.showName2
        })
        .catch((err) => {
          this.addAndChangeLoading = false
          this.$message.error(err.message)
        })
    },
    // 点击删除
    detailsClick (row) {
      managerdDelete(row.id)
        .then((res) => {
          this.$message.success('删除成功')
          this.getSeatchData(this.searchFrom)
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 添加-车型下拉框改变时
    carTypeChange (val) {
      listByTypeId(val)
        .then((res) => {
          this.tonnageOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 计价方式改变时
    pricingTypeChange (val) {
      this.pricingMethodOptions.forEach((item, index) => {
        if (val == item.itemNo) {
          this.jiJiaType = item.showName2
        }
      })
    },
    // 点击提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            this.addAndChangeLoading = true
            addVehicleModelPrice({
              vhcTypeId: this.addAndChangeFrom.carType, // 车辆类型id，
              tonnageModelId: this.addAndChangeFrom.tonnage, // 吨位/机型id(可无),
              pricingMethod: this.addAndChangeFrom.pricingMethod, // 计价方式，
              unitPrice: this.addAndChangeFrom.monovalent // 单价
            }).then((res) => {
              this.addAndChangeLoading = false
              this.$message.success('添加成功')
              this.addAndChangeMark = false
              this.getSeatchData(this.searchFrom)
            }).catch((err) => {
              this.addAndChangeLoading = false
              this.$message.error(err.message)
            })
          } else {
            this.addAndChangeLoading = true
            updatePrice({
              id: this.rowId, // id，
              unitPrice: this.addAndChangeFrom.monovalent // 单价
            }).then((res) => {
              this.addAndChangeLoading = false
              this.$message.success('修改成功')
              this.addAndChangeMark = false
              this.getSeatchData(this.searchFrom)
            }).catch((err) => {
              this.addAndChangeLoading = false
              this.$message.error(err.message)
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 点击取消
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.addAndChangeMark = false
    },
    closeDialog (formName) {
      this.$refs[formName].resetFields()
      // this.addAndChangeMark = false
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
.searchBox {
  margin-left: 25px;
}
.inpBox {
  margin: 10px 0 0 -30px;
}
.searchBtnBox {
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.tongJi {
  display: flex;
  margin-left: 10px;
  margin-bottom: 20px;
}
.tongJi_item {
  margin-right: 20px;
}
.tongJi_item span {
  color: red;
}
</style>
